<template>
    <button @click="open()"><slot></slot></button>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'
    import {MODAL} from "@/store/types/modules";
    import {SET_ID} from "@/store/types/mutations";

    export default {
        props: {
            slideId: Number
        },
        methods: {
            ...mapMutations(MODAL, {
                setActiveId: SET_ID,
            }),
            open() {
                this.id = this.slideId
            }
        },
        computed: {
            ...mapState(MODAL, {
                getActiveId: 'id',
            }),
            id: {
                get() {
                    return this.getActiveId
                },
                set(value) {
                    this.setActiveId(value)
                },
            }
        }
    }
</script>